import Header from './components/Header';
import Faq from './sections/Faq';
import Lodging from './sections/Lodging';
import Opener from './sections/Opener';
import Photos from './sections/Photos';
import Schedule from './sections/Schedule';
import Travel from './sections/Travel';
import Us from './sections/Us';

export default function App() {
  return (
    <div className='h-screen flex-1 flex flex-col justify-start items-center'>
      {/* CONTENT */}
      <div className='w-full h-[60px] min-h-[60px]' />
      <div className='h-full flex-1 flex flex-col justify-start items-center gap-10'>
        <Opener />
        <Us />
        <Photos />
        <Lodging />
        <Travel />
        <Schedule />
        <Faq />
        <div className='w-full min-h-[100px]' />
      </div>

      {/* NAVBAR */}
      <Header />
    </div>
  );
}
